<template>
  <div class="sjbz">
    <div class="banners">
      <div class="banner-title">
        <div class="t1">数据资产运营</div>
        <div class="t2">全国开展公共数据集中授权运营</div>
      </div>
      <video
        src="../assets/img/banner1.mp4"
        autoplay
        loop
        muted
        style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0;"
      />
    </div>
    <div class="content-cr">
      <div
        style="display: flex; justify-content: space-between;margin-top: 60px;"
      >
        <img
          style="margin-bottom: -200px;width: 400px;height: 600px;object-fit: contain;"
          src="../assets/img/zq/tp3.png"
          alt=""
        />
        <div style="margin-left: 40px;">
          <div
            style="font-size: 32px;margin-bottom: 50px;list-style: 60px;color:#333"
          >
          数据资产运营
          </div>
          <div style="font-size: 24px;line-height: 48px;color:#666">
            中启联信科技集团在全国开展公共数据集中授权运营，率先形成统一的城市级、行业级公共数据运营服务渠道。集团将进一步聚合公共、行业、社会数据资源，加快实现数据归集整合，构建数据资源湖，为各类市场化主体提供合规、安全的数据产品以及数据标准化、评估定价、数据咨询、解决方案等数据资产运营、流通服务及数据增值服务。
          </div>
        </div>
      </div>
    </div>
    <div class="content-cr">
      <div
        style="display: flex; justify-content: space-between;margin-top: 60px;"
      >
      <div style="margin-right: 40px;">
          <div
            style="font-size: 32px;margin-bottom: 50px;list-style: 60px;color:#333"
          >
          “启信”公共数据运营服务平台
          </div>
          <div style="font-size: 24px;line-height: 48px;color:#666">
            “启信”公共数据运营服务平台以城市数据资源体系数据为底座，运用隐私计算、区块链等新兴技术手段，实现公共数据“可用不可见、可控可追溯”，在确保数据安全和隐私的前提下，打通政企数据融合通道，着力解决企业的数据要素难题。通过专业化运营、精准化服务，支持市场主体运用数据要素打造新产品、洞察产业发展趋势、助力产业建圈强链、改善民生服务体验，为践行新发展理念的大数据服务提供支撑。
          </div>
        </div>
        <img
          style="margin-top:-100px;width: 400px;height: 600px;object-fit: contain;"
          src="../assets/img/zq/tp4.png"
          alt=""
        />
      </div>
    </div>
    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">运营成果</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <ul
            style="display: flex;justify-content: space-between;width:1400px;margin: 80px auto 40px;"
          >
            <li class="li1">
              <img src="../assets/img/zq/cg1.png" style="width: 50px;" />
              <div class="li-num">40<span class="num-em">+</span></div>
              <div class="li-text">已支撑应用场景</div>
            </li>
            <li class="li1">
              <img src="../assets/img/zq/cg2.png" style="width: 50px;" />
              <div class="li-num">
                250<span class="num-em"><span class="num-em">+</span></span>
              </div>
              <div class="li-text">已上线数据服务产品</div>
            </li>
            <li class="li1">
              <img src="../assets/img/zq/cg3.png" style="width: 50px;" />
              <div class="li-num">570<span class="num-em">+</span></div>
              <div class="li-text">已接入政务数据资源</div>
            </li>
            <li class="li1">
              <img src="../assets/img/zq/cg4.png" style="width: 50px;" />
              <div class="li-num">46</div>
              <div class="li-text">已接入数据提供单位</div>
            </li>
          </ul>
          <div class="zq-cj">
              <div>
                <img src="../assets/img/zq/hh1.png" style="width: 100px;" />
                <div class="cj-text">金融科技</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh2.png" style="width: 100px;" />
                <div class="cj-text">企业数字化转型</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh3.png" style="width: 100px;" />
                <div class="cj-text">产业园区发展</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh4.png" style="width: 100px;" />
                <div class="cj-text">民生服务</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh5.png" style="width: 100px;" />
                <div class="cj-text">智慧物流</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh6.png" style="width: 100px;" />
                <div class="cj-text">供应链金融</div>
              </div>
              <div>
                <img src="../assets/img/zq/hh7.png" style="width: 100px;" />
                <div class="cj-text">跨境贸易</div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Banner from "../components/Banner";
export default {
  metaInfo: {
    title: "中启联信_数据资产运营",
    meta: [
      { name: "keywords", content: "中启联信、数据资产运营" },
      { name: "description", content: "中启联信、数据资产运营" },
    ],
  },
  data() {
    return {
      hovercjIndex: null,
      hoverIndex: 0,
      tabPosition: "left",
      activeName: "first",
      cjList: [
        {
          title: "内容审核场景",
          content:
            "通过专业的标注实现对问答评论、昵称签名、日记帖子、 恶意推广、图文图集、音视频弹幕中的内容合规合法性进行识别。",
        },
        {
          title: "智能安防",
          content:
            "核心能力包括人脸打点、骨骼关键点、人体拉框、视频切分、目标跟踪、语义分割等标注类型，支持平安城市、车辆人流监测人脸识别等场景数据标注。",
        },
        {
          title: "智能金融",
          content:
            "核心能力包括车辆保险鉴定、人物对话转写、命名实体识别、票据文字识别(OCR)、人脸标注、风控数据标注等标注类型，支持身份认证、智能风控、智慧柜台等场景数据标注。",
        },
        {
          title: "智能驾驶",
          content:
            "核心能力包括图片通用拉框、车道线、DMS、3D点云、2D/3D融合、全景语义分割等标注类型，支持自动驾驶、智能驾舱、自动泊车等场景数据标注。",
        },
        {
          title: "智能家居",
          content:
            "核心能力包括人物语音转写、行为意图、声纹识别、领域识别、语句泛化、语义分割等标注类型，支持智能音箱、智能电视、智能扫地机器人等场景数据标注。",
        },
        {
          title: "新零售",
          content:
            "核心能力包括商品分类识别、票据识别转写、服饰拉框、商品属性、人脸表情、目标跟踪等标注类型，支持智慧门店、无人货柜、虚拟试衣等场景数据标注。",
        },
      ],
      ysLIst: [
        {
          img: require("../assets/img/zq/caiji-youshi-1-0.png"),
          title: "数据安全专业的团队",
          content:
            "在全国自建多个数据中心，有众多稳定的外包合作供应商，包括众包资源。专属项目经理全程多维度管控，确保数据交付质量。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-1.png"),
          title: "数据标注的全面覆盖",
          content:
            "包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-2.png"),
          title: "定制化数据采集流程",
          content:
            "拥有庞大的众包团队和各领域合作伙伴，支持全球数据采集需求，针对细分AI应用场景进行数据定制。数据采集支持大规模数据采集及数据清理、质量检测、预识别等，保证项目交付的质量和效率。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-3.png"),
          title: "成品数据集的多样性和实用性",
          content:
            "提供200+成品数据集，包括ASR、文本、发音词典、图像及视频，为快速部署提供高质量数据支持。",
        },
      ],
      sjList: [
        {
          title: "数据治理",
          content:
            "确定数据标准;\n数据清洗;\n数据管理能力评估;\n数据资源目录梳理;\n……",
        },
        {
          title: "数据确权",
          content:
            "了解数据登记情况;\n界定数据来源、持有加工、流通、使用过程中的合法权利;\n明确权利或权利组合;\n获取相关权证材料;\n……",
        },
        {
          title: "数据入表专业咨询",
          content:
            "数据资产确认条件;\n基于场景的预期收益合理性判断;\n资产分类的合理性和确定依据分析;\n后续计量的价值影响分析;\n……",
        },
        {
          title: "数据资产质量评价",
          content:
            "明确数据质量评价对象及范围;\n建立质量要素评价指标体系;\n执行数据质量评价程序;\n撰写数据质量评价报告;\n……",
        },
        {
          title: "数据资产价值评估",
          content:
            "明确评估对象和范围明确应用场景和资产类型;\n数据资产评估方法适用性分析;\n数据资产价值评估;\n出具价值评估报告;\n……",
        },
      ],
      itemList: [
        {
          bg: require(`@/assets/img/advantage-0.png`),
          title: "上千次项目打磨",
        },
        {
          bg: require(`@/assets/img/advantage-1.png`),
          title: "100%项目交付质量",
        },
        {
          bg: require(`@/assets/img/advantage-2.png`),
          title: "量身打造定制化方案",
        },
        { bg: require(`@/assets/img/advantage-3.png`), title: "50+技术软著" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sjbz {
  width: 100%;
  .content-3 {
    margin-top: 80px;
    .content-3-1 {
      text-align: center;
    }
    .content-3-2 {
      width: 1400px;
      margin: 68px auto;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 288px;
        height: 274px;
        background: #3a4354;
        border-radius: 6px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .box1-1 {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 45px;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          line-height: 24px;
        }
        .box1-2 {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          color: #fff;
          text-align: center;
          opacity: 0;
          -webkit-animation: advantageHide 1s;
          animation: advantageHide 1s;
          @keyframes advantageHide {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .content-2 {
    background: #f9fbff;
    width: 100%;
    padding-top: 60px;
    min-width: 1200px;
    .content-2-3 {
      // width: 1200px;
      margin: 20px auto;
      ::v-deep .el-tabs__nav-scroll {
        width: 10%;
        margin: 0 auto;
      }
      .content-2-3-1 {
        width: 100%;
        min-width: 1200px;
        height: 23.43vw;
        background: #2b3953;
        position: relative;
        margin-top: 4.9vw;
        .text1 {
          text-align: left;
          color: #fff;
          width: 62.5vw;
          margin: 0 auto;
          padding-top: 5.28vw;
        }
        .img1 {
          opacity: 1;
          width: 50vw;
          height: 26.84vw;
          position: absolute;
          right: 0;
          bottom: 0;
          transition: all 0.5s ease-in 0.5s;
          animation: fadeIn 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        .img2 {
          width: 30.15vw;
          height: 15.98vw;
          position: absolute;
          right: 30.57vw;
          bottom: 0;
          animation: slide-in-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            forwards;
          @keyframes slide-in-bottom {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .content-2-1 {
      text-align: center;
    }
    .content-2-2 {
      margin: 32px auto;
      text-align: center;
      .tabs {
        margin: 0 auto;

        ::v-deep .el-radio-button__inner {
          width: 400px;
          height: 48px;
          line-height: 24px;
          font-size: 20px;
        }
      }
    }
  }
  .content-1 {
    background: #fff;
    width: 100%;
    min-width: 1400px;
    .content-1-1 {
      text-align: center;
      .title-top {
        display: flex;
        justify-content: center;
        align-items: center;
        .title1 {
          font-size: 36px;
          margin: 0px 20px;
        }
      }
      // &:active {
      //   background: linear-gradient(135deg, #526aff, #7caefb) !important;
      //   color: #fff;
      // }
    }
    .zq-cj{
      width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
     .cj-text{
      margin-bottom: 50px;
      font-size: 18px;
      color:#666;
     }
    }
    .li1 {
    text-align: center;
    list-style: none;
    .li-num {
      margin-top: 12px;
      font-size: 80px;
      color: #7caefb;
      line-height: 1;
      // font-family: DINCond-Bold;
      .num-em {
        font-size: 25px;
        color: #7caefb;
        font-weight: bold;
        margin-left: 5px;
      }
    }
    .li-text {
      margin-top: 12px;
      font-size: 16px;
      color: #8e96a1;
      text-align: center;
    }
  }
  }
  .content-cr {
    width: 1400px;
    margin: 0 auto;
  }
  .bz-4 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-4-card {
      width: 432px;
      height: 210px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-bottom: 20px;
      position: relative;
      .card-title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
      }
      .card-content {
        width: calc(100% - 80px);
        height: calc(100% - 80px);
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        padding: 40px;
      }
    }
  }
  .bz-3 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-3-1 {
      font-size: 32px;
      font-weight: bold;
      color: #7caefb;
    }
  }
  .bz-2 {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 38px;
    margin: 40px auto;
    .bz-2-card {
      .bz-2-card-1 {
        font-size: 24px;
        font-weight: bold;
        color: rgb(24, 24, 24);
        line-height: 25px;
        margin: 30px auto 16px;
      }
      .bz-2-card-2 {
        text-align: left;
        text-indent: 2em;
        font-size: 18px;
        font-weight: 400;
        color: rgb(112, 117, 127);
        line-height: 30px;
        width: 540px;
        margin: auto;
      }
      width: calc(50% - 40px);
      height: 330px;
      text-align: center;
      margin-bottom: 18px;
      margin-left: 11px;
      margin-right: 11px;
      background: transparent;
      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(220, 226, 239);
      border-image: initial;
      &:hover {
        box-shadow: rgba(0, 0, 0, 0.06) 4px 6px 20px 0px;
        background: rgb(255, 255, 255);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(220, 226, 239);
        border-image: initial;
      }
    }
  }
  .bz-1 {
    margin: 40px 0;
    width: 100%;
    min-width: 1400px;
    .bz-list {
      width: 1400px;
      display: flex;
      justify-content: space-between;
      margin: 0px auto;
      .img-1 {
        width: 516px;
        height: 326px;
      }
      .list-r {
        width: 592px;
        height: 345px;
        position: relative;
        .list-r-2 {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          .list-r-2-1 {
            width: 295px;
            margin-top: 10px;
            color: rgb(58, 67, 84);
            font-size: 24px;
            line-height: 60px;
            position: relative;
            text-align: left;
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              position: relative;
              top: -3px;
              margin-right: 10px;
              background: rgb(82, 106, 255);
              border-radius: 50%;
            }
          }
        }
        .list-r-1 {
          color: rgb(58, 67, 84);
          font-size: 28px;
          font-weight: 700;
          position: relative;
          display: flex;
          justify-content: space-between;
          z-index: 3 !important;
          &::before {
            content: "";
            position: absolute;
            left: -2px;
            top: 1px;
            display: block;
            width: 60px;
            height: 36px;
            z-index: -1 !important;
            background: linear-gradient(
              315deg,
              rgba(124, 174, 251, 0),
              rgb(82, 106, 255)
            );
            border-radius: 4px;
          }
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 42px;
          height: 12px;
          z-index: 1;
          background: linear-gradient(
            95deg,
            rgba(124, 174, 251, 0),
            rgb(82, 106, 255)
          );
          border-radius: 4px;
        }
      }
    }
  }
  .content-1-2 {
    display: flex;
    margin-top: 30px;
    .home-app-left {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
      .t1 {
        font-size: 20px;
        color: #fff;
        line-height: 60px;
        margin: 20px 0;
      }
    }
    .home-app-center {
      width: 900px;
      height: 247px;
      background-image: url(https://databaker-gw-static.oss-accelerate.aliyuncs.com/assets/images/newHome/app-bg.png);
      background-size: 100% 100%;
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 0 6px 6px 0;
      position: relative;
      text-align: center;
      font-size: 40px;
      padding-top: 220px;
    }
    .home-app-right {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
    }
  }
}
.home-achieve {
  position: relative;
  width: 1400px;
  margin: -60px auto;
  display: flex;
  z-index: 3;
  justify-content: space-between;
  .cards {
    transform: translateY(0px);
    opacity: 1;
    animation-delay: 200ms;
    width: 388px;
    height: 112px;
    background: #fff;
    box-shadow: 2px 6px 10px 0 rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    display: flex;
  }
}
.banners {
  width: 100%;
  height: 400px;
  position: relative;
  .banner-title {
    position: absolute;
    z-index: 3;
    width: 1400px;
    min-width: 1400px;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    .t1 {
      font-size: 2.2vw;
      font-family: Alibaba-PuHuiTi-Bold;
      color: #3a4354;
      font-weight: bold;
    }
    .t2 {
      font-size: 1.2vw;
      width: 567px;
      font-weight: 400;
      color: #3a4354;
      line-height: 40px;
      margin-top: 23px;
      font-family: Alibaba-PuHuiTi-Regular;
    }
  }
  video {
    height: 100%;
    width: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    // bottom: 0px;
    z-index: -1;
  }
}
</style>
